import { Flex, Skeleton } from 'antd';
import styles from './client-info.module.scss';

export const ClientInfoSkeleton = () => (
  <Flex align="start" justify="start" gap={24} vertical className={styles.root}>
    <Flex gap={12} align="center">
      <Skeleton.Avatar active size={'large'} shape="circle" className={styles.skeleton__avatar} />

      <Flex gap={10} vertical>
        <Skeleton.Input active size="default" />
        <Skeleton.Input active size="default" />
      </Flex>
    </Flex>

    <Flex gap={12} align="center" vertical style={{ width: '100%' }}>
      <Skeleton.Input active size="small" block />

      <Flex vertical gap={2} style={{ width: '100%' }}>
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
      </Flex>

      <Flex vertical gap={2} style={{ width: '100%' }}>
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block style={{ height: '116px' }} />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
      </Flex>
    </Flex>

    <Flex gap={12} align="center" vertical style={{ width: '100%' }}>
      <Skeleton.Input active size="small" block />

      <Flex vertical gap={2} style={{ width: '100%' }}>
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
      </Flex>
    </Flex>

    <Flex gap={12} align="center" vertical style={{ width: '100%' }}>
      <Skeleton.Input active size="small" block />

      <Flex vertical gap={2} style={{ width: '100%' }}>
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
      </Flex>
    </Flex>

    <Flex gap={12} align="center" vertical style={{ width: '100%' }}>
      <Skeleton.Input active size="small" block />

      <Flex vertical gap={2} style={{ width: '100%' }}>
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
        <Skeleton.Input active size="default" block />
      </Flex>
    </Flex>
  </Flex>
);
